import React from "react";
import HeroSection from "../components/common/HeroSection";

const PrivacyPolicy = () => {
  return (
    <div>
      {/* <HeroSection
        title="Privacy Policy"
        breadcrumb={[{ name: "Privacy Policy" }]}
        background="/assets/images/about/bg.png"
      /> */}
      <div className="privacy-policy-page min-h-screen bg-gray-50 py-20 px-4 md:px-8 lg:px-16">
        <div className="container mx-auto max-w-4xl bg-white rounded-lg shadow-lg p-10">
          <h1 className="text-5xl text-center font-extrabold mb-10 text-gray-900 tracking-tight">
          Privacy Policy
        </h1>

          <p className="text-gray-500 text-center mb-16 text-sm uppercase tracking-wide">
            <strong>Last Updated:</strong> September 26, 2025
          </p>

          <p className="mb-10 text-gray-700 font-bold leading-relaxed text-lg">
            TISSA Technology LLP (“we”, “us”, “our”) values your privacy. This
            Privacy Policy explains how we collect, use, disclose, and protect
            your personal information when you visit our website{" "}
            <a
              href="https://tissatech.com/"
              className="text-indigo-600 hover:text-indigo-700 underline transition-colors duration-300"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://tissatech.com/
            </a>{" "}
            (the “Site”) or use our services.
          </p>

          {[
            {
              title: "1. Information We Collect",
              content: (
                <>
                  <h3 className="text-xl font-semibold mb-3 mt-6 text-gray-800">
                    a) Information You Provide Directly
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
                    <li>
                      Contact details: name, email address, phone number,
                      business name, etc., when you fill out contact or
                      consultation forms.
                    </li>
                    <li>
                      Service preferences: which services you are interested in
                      (e.g. custom software development, Odoo services,
                      integration, big data, consulting).
                    </li>
                    <li>
                      Any other information you choose to provide (e.g.
                      messages, feedback).
                    </li>
                  </ul>

                  <h3 className="text-xl font-semibold mb-3 text-gray-800">
                    b) Information Collected Automatically
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>
                      Log data: such as your IP address, browser type, operating
                      system, referring URLs, pages viewed, and the dates/times
                      of your visits.
                    </li>
                    <li>
                      Cookies and similar tracking technologies: to help us
                      analyze trends, manage the Site, track users’ movements
                      around the Site, and gather demographic information.
                    </li>
                  </ul>
                </>
              ),
            },
            {
              title: "2. How We Use Your Information",
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    To provide and manage the services you request (e.g.
                    responding to inquiries, delivering consulting, project
                    execution).
                  </li>
                  <li>
                    To communicate with you (e.g. send confirmations, updates).
                  </li>
                  <li>To improve our Site, services, and user experience.</li>
                  <li>
                    To comply with legal obligations, enforce our terms, prevent
                    misuse or fraud.
                  </li>
                  <li>To personalize your experience on our Site.</li>
                </ul>
              ),
            },
            {
              title: "3. Cookies and Tracking Technologies",
              content: (
                <>
                  <p className="text-gray-700 mb-4 leading-relaxed">
                    We use cookies and similar technologies for:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
                    <li>Essential Site functionality.</li>
                    <li>Analytics (to understand how users use our Site).</li>
                    <li>
                      Marketing or advertising (with appropriate consent where
                      required).
                    </li>
                  </ul>
                  <p className="text-gray-700 leading-relaxed">
                    You may choose to disable cookies via your browser settings,
                    though this may limit some site functionality.
                  </p>
                </>
              ),
            },
            {
              title: "4. Sharing and Disclosure of Information",
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>
                    With service providers: third‑party companies who perform
                    services on our behalf (e.g. hosting, email communication,
                    analytics, payment processors).
                  </li>
                  <li>
                    Business transfers: in case of a merger, acquisition, or
                    sale of company assets.
                  </li>
                  <li>
                    Legal obligations: where required by law or to respond to
                    lawful requests.
                  </li>
                  <li>
                    Protection of rights: to protect our rights, safety,
                    property, or that of others.
                  </li>
                </ul>
              ),
            },
            {
              title: "5. Data Security",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  We implement reasonable and appropriate technical and
                  organizational measures to protect your personal information.
                  However, no method of transmission or storage is completely
                  secure.
                </p>
              ),
            },
            {
              title: "6. Data Retention",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  We retain personal information only as long as necessary to
                  fulfill the purposes it was collected for, or as required by
                  law. Once no longer needed, data will be securely deleted or
                  anonymized.
                </p>
              ),
            },
            {
              title: "7. Your Rights",
              content: (
                <>
                  <p className="text-gray-700 mb-4 leading-relaxed">
                    Depending on your location, you may have rights including:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Access, correction, or deletion of your data.</li>
                    <li>Restriction or objection to processing.</li>
                    <li>Data portability.</li>
                  </ul>
                  <p className="text-gray-700 mt-4 leading-relaxed">
                    Contact us to exercise your rights.
                  </p>
                </>
              ),
            },
            {
              title: "8. Children’s Privacy",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  Our services are not intended for children under 16. We do not
                  knowingly collect data from them. If such information is
                  identified, it will be deleted.
                </p>
              ),
            },
            {
              title: "9. Third‑Party Links",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  Our Site may contain links to third‑party websites. We are not
                  responsible for their privacy practices and encourage you to
                  review their policies.
                </p>
              ),
            },
            {
              title: "10. Changes to This Privacy Policy",
              content: (
                <p className="text-gray-700 leading-relaxed">
                  We may update this Privacy Policy. Updates will be posted on
                  this page with a revised “Last Updated” date.
                </p>
              ),
            },
            {
              title: "11. Contact Us",
              content: (
                <address className="not-italic text-gray-700 space-y-2 leading-relaxed">
                  <p>TISSA Technology LLC</p>
                  <p>
                    2001 Timberloch Place, Suite 500 Woodlands, Houston, Texas 77380
                  </p>
                  <p>
                    Email:{" "}
                    <a
                      href="mailto:connect@tissatech.com"
                      className="text-indigo-600 hover:underline"
                    >
                      connect@tissatech.com
                    </a>
                  </p>
                  <p>
                    Phone:{" "}
                    <a
                      href="tel:+1-512-203-7627"
                      className="text-indigo-600 hover:underline"
                    >
                      +1-512-203-7627
                    </a>
                  </p>
                  <p>
                    Website:{" "}
                    <a
                      href="https://tissatech.com"
                      className="text-indigo-600 hover:underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://tissatech.com
                    </a>
                  </p>
                </address>
              ),
            },
          ].map(({ title, content }, i) => (
            <section
              key={i}
              className="mb-12 border-b border-gray-200 pb-8 last:border-0 last:pb-0"
            >
              <h2 className="text-3xl font-bold mb-5 text-gray-900 tracking-wide">
                {title}
              </h2>
              {content}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
